<template>
  <a-row>
    <a-table
        :loading="loading"
        :pagination="false"
        :rowKey="event => event.id"
        size="small"
        :columns="columns"
        :dataSource="dataSource.data"
        :width="'100%'"
        :style="{margin:'auto',background:'#fff'}"
    >
      <span slot="data" slot-scope="data,record">
          <template v-if="record.data.type === 'campaign_completed'">
            <span class="text-success">{{ record.data.message }}</span>
             <a-tooltip placement="top">
              <template slot="title">
                <span>{{ 'Go to the campaign : ' + record.notifiable_id }}</span>
              </template>
               <router-link :to="'/admin/' + record.data.redirect">
                 <a-icon type="link" :style="{ fontSize: '20px', color: '#08c' }"/>
               </router-link>
            </a-tooltip>
          </template>
          <template v-else-if="record.data.type === 'campaign_failed'">
             <span class="text-danger">{{ record.data.message }}</span>
              <a-tooltip placement="top">
              <template slot="title">
                <span>{{ 'Go to the campaign : ' + record.notifiable_id }}</span>
              </template>
               <router-link :to="'/admin/' + record.data.redirect">
                 <a-icon type="link" :style="{ fontSize: '20px', color: '#08c' }"/>
               </router-link>
            </a-tooltip>
          </template>
          <template v-else-if="record.data.type === 'campaign_paused'">
            <span class="text-warning">{{ record.data.message }}</span>
              <a-tooltip placement="top">
              <template slot="title">
                <span>{{ 'Go to the campaign : ' + record.notifiable_id }}</span>
              </template>
               <router-link :to="'/admin/' + record.data.redirect">
                 <a-icon type="link" :style="{ fontSize: '20px', color: '#08c' }"/>
               </router-link>
            </a-tooltip>
          </template>
          <template v-else-if="record.data.type === 'campaign_resumed'">
              <span class="text-success">{{ record.data.message }}</span>
              <a-tooltip placement="top">
              <template slot="title">
                <span>{{ 'Go to the campaign : ' + record.notifiable_id }}</span>
              </template>
               <router-link :to="'/admin/' + record.data.redirect">
                 <a-icon type="link" :style="{ fontSize: '20px', color: '#08c' }"/>
               </router-link>
            </a-tooltip>
          </template>
          <template v-else-if="record.data.type === 'site_registered'">
              <span class="text-success">{{ record.data.message }}</span>
              <a-tooltip placement="top">
              <template slot="title">
                <span>{{ 'Go to the site : ' + record.notifiable_id }}</span>
              </template>
               <router-link :to="'/admin/sites/' + record.notifiable_id">
                 <a-icon type="link" :style="{ fontSize: '20px', color: '#08c' }"/>
               </router-link>
            </a-tooltip>
          </template>
          <template v-else-if="record.data.type === 'import_completed'">
           <span class="text-success">{{ record.data.message }}</span>
             <a-tooltip placement="top">
              <template slot="title">
                <span>{{ 'Go to the list : ' + record.notifiable_id }}</span>
              </template>
               <router-link :to="'/admin/' + record.data.redirect">
                 <a-icon type="link" :style="{ fontSize: '20px', color: '#08c' }"/>
               </router-link>
            </a-tooltip>
          </template>
          <template v-else-if="record.data.type === 'import_failed'">
              <span class="text-danger">{{ record.data.message }}</span>
          </template>
          <template v-else>
              <span class="text-success">{{ record.data.message }}</span>
               <router-link v-if="record.data.redirect" :to="'/admin/' + record.data.redirect">
                 <a-icon type="link" :style="{ fontSize: '20px', color: '#08c' }"/>
               </router-link>
          </template>
      </span>
        <span v-if="record.data.error" slot="expandedRowRender" slot-scope="record" style="margin: 0">
            <small style="padding: 10px">{{ record.data.error }}</small>
        </span>
    </a-table>
    <template v-if="dataSource.data">
      <a-pagination
          @change="pagination"
          v-model="dataSource.meta.current_page"
          :pageSize="dataSource.meta.per_page"
          :defaultCurrent="1"
          :total="dataSource.meta.total"
          :style="{justifyContent:'flex-end',display:'flex', padding: '20px'}"
      />
    </template>
  </a-row>
</template>
<script>
const columns = [
  {
    title: "Events",
    dataIndex: "data",
    width: "75%",
    scopedSlots: { customRender: "data" }
  },
  {
    title: "status",
    dataIndex: "status",
  },
  {
    title: "Time",
    dataIndex: "created_at"
  },
];

export default {
  name: 'CampaignsTable',
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    dataSource: {
      required: true,
    }
  },
  data() {
    return {
      columns
    };
  },
  methods: {
    pagination: function (page) {
      this.$emit('pagination', page);
    }
  }
}

</script>
<style  scoped>
.text-success {
  color: #56b756;
  padding-right: 10px;
}
.text-warning {
  color: #caca55;
  padding-right: 10px;
}
.text-danger {
  color: #e96363;
  padding-right: 10px;
}
</style>